export const RulesConstants = {
    READ: 'read',
    WRITE: 'write',
    DESK: 'desk',
    EXTRAS: 'Extras',
    CONTACT_EXTRAS: 'Contact.Extras',
    DEFAULT_TEAM_NAME: 'Default',
    DEFAULT_OPERATOR: 'Or',
    BASE_URL: '/rules',
    RULE_QUEUE_URL: '/rules/queue/',
    DESTINATION_DESK: 'postmaster@desk.',
    STATES: {
        ADDING: 'ADDING',
        EDITING: 'EDITING',
        VIEWING: 'VIEWING',
    },
};
export const RulesTracks = {
    PAGE_OPENED: 'helpdesk-rules-opened ',
    RULE_ADDED: 'helpdesk-rule-added ',
    RULE_SAVED: 'helpdesk-rule-saved ',
    RULE_DELETED: 'helpdesk-rule-deleted ',
    CONDITION_ADDED: 'helpdesk-rule-condition-added ',
    CONDITION_DELETED: 'helpdesk-rule-condition-deleted ',
    BUILDER_CONDITION_DELETED: 'builder-helpdesk-condition-deleted',
    RULE_ENABLED: 'helpdesk-rules-enabled ',
    RULE_DISABLED: 'helpdesk-rules-disabled ',
    RULES_SEARCHED: 'helpdesk-rules-searched ',
    CLEAR_SEARCH: 'helpdesk-rules-clear-search ',
    SOURCE: {
        PORTAL: 'portal',
        BUILDER: 'builder',
    },
};
